// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-container {
    position: relative;
    display: flex;
    align-items: center;
}

.shape {
    cursor: pointer;
}

.search-dropdown {
    position: absolute; /* Ensure it floats above other content */
    top: 100%; /* Position it below the search button */
    left: 0; /* Align with the left edge of the container */
    width: 200px; /* Set a fixed width for the input field */
    max-height: 0; /* Start with no height */
    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
    opacity: 0;
    overflow: hidden;
    z-index: 1000; /* Ensure it appears in front of other content */
    background-color: white; /* Optional: background color for better visibility */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: add a shadow for better visibility */
}

.search-dropdown.open {
    max-height: 500px; /* Expand height to 500px */
    opacity: 1;
}

.search-input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    box-sizing: border-box;
    display: block;
}

.suggestions-list {
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 450px; /* Ensure space for the input field */
    overflow-y: auto; /* Add scroll if there are too many suggestions */
}

.suggestions-list li {
    padding: 8px;
    cursor: pointer;
}

.suggestions-list li:hover, .suggestions-list li.selected {
    background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Search/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB,EAAE,yCAAyC;IAC7D,SAAS,EAAE,wCAAwC;IACnD,OAAO,EAAE,8CAA8C;IACvD,YAAY,EAAE,0CAA0C;IACxD,aAAa,EAAE,yBAAyB;IACxC,iEAAiE;IACjE,UAAU;IACV,gBAAgB;IAChB,aAAa,EAAE,gDAAgD;IAC/D,uBAAuB,EAAE,qDAAqD;IAC9E,wCAAwC,EAAE,iDAAiD;AAC/F;;AAEA;IACI,iBAAiB,EAAE,2BAA2B;IAC9C,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,iBAAiB,EAAE,qCAAqC;IACxD,gBAAgB,EAAE,iDAAiD;AACvE;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".search-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.shape {\n    cursor: pointer;\n}\n\n.search-dropdown {\n    position: absolute; /* Ensure it floats above other content */\n    top: 100%; /* Position it below the search button */\n    left: 0; /* Align with the left edge of the container */\n    width: 200px; /* Set a fixed width for the input field */\n    max-height: 0; /* Start with no height */\n    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;\n    opacity: 0;\n    overflow: hidden;\n    z-index: 1000; /* Ensure it appears in front of other content */\n    background-color: white; /* Optional: background color for better visibility */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: add a shadow for better visibility */\n}\n\n.search-dropdown.open {\n    max-height: 500px; /* Expand height to 500px */\n    opacity: 1;\n}\n\n.search-input {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ccc;\n    box-sizing: border-box;\n    display: block;\n}\n\n.suggestions-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    max-height: 450px; /* Ensure space for the input field */\n    overflow-y: auto; /* Add scroll if there are too many suggestions */\n}\n\n.suggestions-list li {\n    padding: 8px;\n    cursor: pointer;\n}\n\n.suggestions-list li:hover, .suggestions-list li.selected {\n    background-color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
